import { Image } from '@wilkins-software/redwood-utils';
import { BsChatRightQuoteFill } from 'react-icons/bs';

export const SingleTestimonial = ({
  image,
  imageWidth,
  imageHeight,
  details,
  name,
  position,
}: {
  image: string;
  /** Intrinsic pixel size of `image` — required so the box reserves space. */
  imageWidth: number;
  imageHeight: number;
  details: string;
  name: string;
  position: string;
}) => {
  return (
    <div className="relative z-10 flex min-w-full justify-center">
      <div className="relative w-full md:w-11/12 lg:w-10/12 xl:w-8/12">
        <div className="glass-panel relative z-10 items-stretch overflow-hidden rounded-[32px] md:flex">
          <div className=" w-full max-w-[150px] px-6 pt-10 sm:px-10 md:max-w-[270px] md:px-0 md:pt-0">
            <Image
              src={image}
              alt={name}
              width={imageWidth}
              height={imageHeight}
              sizes="(min-width: 768px) 270px, 150px"
              className="size-full object-cover"
            />
          </div>
          <div className="w-full px-6 py-10 sm:px-10 md:py-14">
            <div className="icon mb-5">
              <BsChatRightQuoteFill
                className="size-12 text-primary"
                aria-hidden
                focusable="false"
              />
            </div>
            <h3 className=" mb-1 text-xl font-semibold">{name}</h3>
            {/* Role line, not a heading — it describes the person named in the
                h3 above and used to break the heading sequence as an h6. */}
            <p className="mb-4 text-sm font-bold text-primary">{position}</p>
            <p className="text-sm font-medium text-slate-500">“{details}”</p>
          </div>
          <span className="absolute bottom-0 right-0 z-[-1]">
            <svg
              width="540"
              height="340"
              viewBox="0 0 540 340"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.05"
                d="M410 -14C411.619 0.0555554 419.59 30 438.528 37.3333C462.201 46.5 474.948 52 481.017 74C487.087 96 501.655 127.778 549 129"
                stroke="#3056D3"
                strokeWidth="2"
              />
              <path
                opacity="0.05"
                d="M193 0C220.802 44.6714 244.632 50.4524 286.996 57.8101C339.951 67.0071 343.034 94.0439 347.895 143.211C352.756 192.379 390.259 257.518 520 227.299"
                stroke="#3056D3"
                strokeWidth="3"
              />
              <path
                opacity="0.05"
                d="M2 114.5C13.6667 131 55 155.1 127 119.5C217 75 276 131.5 269.5 182C263 232.5 273 330.5 384 329.5"
                stroke="#3056D3"
                strokeWidth="3"
              />
              <path
                opacity="0.05"
                d="M100 335.5C118.667 347.167 156.9 354.8 160.5 292C165 213.5 239 182.5 297 208.5C355 234.5 398 344 461 349"
                stroke="#3056D3"
                strokeWidth="3"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
};
